import { CellStateStyle, Graph } from "@maxgraph/core";
import { CustomCell } from "../models/diagram.models";
import { MaxGraphEventBus } from "./max-graph-event-bus";

/**
 * Serviço responsável por gerenciar o event de mouseOn e mouseLeave do component Graph do diagrama.
 */
export class MaxGraphHoverEventService {

    private readonly HOVER_SUFFIX = "-hover";
    /**
     * Define o comportamento que será executado após remover o mouse do componente.
     */
    onLeave(graph: Graph, cell: CustomCell, maxGraphEventBus: MaxGraphEventBus) {
        maxGraphEventBus.emitHoverLeave(cell);

        if (this.isHovered(graph.getCellStyle(cell))) {
            const image = graph.getCellStyle(cell).image.replace(this.HOVER_SUFFIX, "");
            graph.setCellStyles("image", image, [cell]);
        }
    }

    /**
     * Define a lógica executada ao passar o mouse sobre o componente.
     *
     * Ao passar o mouse sobre o componente, será verificado se existe uma imagem equivalente a imagem
     * utilizada originalmente com o sufixo "-hover". Se existir a imagem será alterada, caso contrário
     * nada será feito.
     *
     * Ex:
     * amp_booster.svg -> amp_booster-hover.svg
     */
    async onEnter(graph: Graph, cell: CustomCell, maxGraph: MaxGraphEventBus) {
        cell.buildPopover?.(graph, cell);
        maxGraph.emitHoverEnter(cell);

        const cellImage = graph.getCellStyle(cell).image;

        if (cellImage) {
            const hoveredImage = cellImage.replace(/(\w+)\.(\w+)/, `$1${this.HOVER_SUFFIX}.$2`);

            if (await this.imageExists(hoveredImage)) {
                graph.setCellStyles("image", hoveredImage, [cell]);
            }
        }
    }

    /**
     * Verifica se a imagem do componente tem o sufixo "-hover"
     */
    private isHovered(cellStateStyle: CellStateStyle) {
        return cellStateStyle.image && cellStateStyle.image.includes(this.HOVER_SUFFIX);
    }

    /**
     * Verifica se a url da imagem a ser utilizada no componente existe.
     */
    private imageExists(url: string): Promise<boolean> {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
        });
    }
}
